module.exports = __webpack_public_path__ + "img/green_076.38131163.png";